import styled, { keyframes } from 'styled-components';

const appearFromTop = keyframes`
  from {
    opacity: 0;
    transform: translateY(-500px);
  }
  to {
    opacity: 1;
    transform: translateY(0px);
  }
`;

const appearBackground = keyframes`
  from {
    background-color: transparent;
  }
  to {
    background-color: rgba(0, 0, 0, 0.5);
  }
`;

export const Container = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  position: fixed;
	top: 0;
  z-index: 10;
  animation: ${appearBackground} 0.5s;
  transition: ${appearBackground} 0.5s;

  .active {
    opacity: 1;
    top: 30%;
    visibility: visible;
    animation: ${appearFromTop} 0.4s;

    @media (max-width: 650px) {
      animation: ${appearFromTop} 0.4s;
    }
  }

  div::-webkit-scrollbar {
    display: none; /* Might be enough */
    background: transparent;
    visibility: hidden;
    width: 0px;
  }
  div {
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    scrollbar-width: none;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #fff;
  top: -500px;
  position: fixed;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.3);
  opacity: 0;
  border-radius: 5px;
  width: 500px;
  padding: 20px 40px;
  visibility: hidden;
  transition: all 0.5s ease-out;

  h1 {
    font-size: 22px;
    font-weight: 500;
    margin-bottom: 20px;
  }

  .div-data {
    display: flex;
    flex-direction: column;
    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    padding: 10px;
    width: 100%;

    h2 {
      font-size: 18px;
      font-weight: 500;
      color: #455a64;
    }
  }

  button {
    font-size: 18px;
    font-weight: 500;
    color: var(--azul-razio);
    border: 2px solid var(--azul-razio);
    border-radius: 8px;
    padding: 7px 30px;
    width: 100%;
    margin: 10px 0;
  }

  .btn-confirm {
    color: #fff;
    background-color: var(--azul-razio);
    margin-top: 20px;
  }

	// 479px
  @media (max-width: 29.9375rem) {
		width: 97%;
  	padding: 20px 5px;
	}
`;
